import { ENVIRONMENT_TYPE } from "./common";

const ENVIRONMENT = {
  environment: process.env.REACT_APP_ENVIRONMENT || ENVIRONMENT_TYPE.DEV,
  ENDPOINT: process.env.REACT_APP_ENDPOINT || "https://api-dev.zenvoya.ai",
  recommendedTripsURL: process.env.REACT_APP_RECOMMENDED_TRIPS_URL || "",
  ENCRYPTION_KEY: process.env.REACT_APP_ENCRYPTION_KEY || "",
  APP_URL: process.env.REACT_APP_APP_URL || "",
  API_KEY: process.env.REACT_APP_API_KEY || "",
};

const {
  ENDPOINT,
  recommendedTripsURL,
  ENCRYPTION_KEY,
  environment,
  APP_URL,
  API_KEY,
} = ENVIRONMENT;

export {
  ENDPOINT,
  recommendedTripsURL,
  ENCRYPTION_KEY,
  environment,
  APP_URL,
  API_KEY,
};
